import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "MaterialService",
  controller: "tb_project_basicinfo",
};

const methods = [
   "AddItem",
   "UpdateItem",
   "DelItem",
   "GetItemById",
   "GetProjectSummary",
   "GetPageContentByConditions"
];

const factory = (Fun) => {
  utils.extend(Fun.prototype, info);
  methods.forEach((path) => {
    Fun.prototype[path] = function(data) {
      return this.post(path, data);
    };
  });
};

const MaterialUsageResourcesApi = ZJApi.defineNewApi("MaterialUsageResourcesApi", factory);

export default MaterialUsageResourcesApi;
